module.exports = "https://trybtryb-legacy.web.app/img/nebulae.66a6c6db.webp";